import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

// Re-export common styles
export { FormPageContainer, FormHeader, FormSubHeader, StyledForm, SubmitButton, ButtonGroupContainer, BackButton } from './MaritalStatusForm.styles'; // Reusing from MaritalStatusForm which re-exports PersonalDetails

// Specific style for Executor section headers
export const ExecutorSectionHeader = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    fontWeight: 500,
}));